import axios from "axios";
//export const baseUrl = "http://aaj-devsfc.centralindia.cloudapp.azure.com";
//export const baseUrl = "http://aajenterprise-sfc-prod.centralindia.cloudapp.azure.com"; // Prod Cluster
export const baseUrl = "https://api.aajswift.com";
//export const baseUrl = "http://localhost";


export const setHeaders = async (headers, AWBNo) => {
  var config = {
    headers: { "Content-Type": "application/json" },
  };
  //let headerarr = [];
  let token = localStorage.getItem("Token");
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  let AuthKey = localStorage.getItem("AuthKey");
  if (AuthKey) {
    config.headers.authkey = AuthKey;
  }
  let emailId = localStorage.getItem("emailId");
  if (emailId) {
    config.headers.userid = emailId;
  }
  if (headers) {
    config.headers = { ...config.headers, ...headers };
  }

  return config;
};
export const setHeadersUpload = async (documentType, AWBNo) => {
  var config = {
    headers: {},
  };
  //let headerarr = [];
  let token = localStorage.getItem("Token");
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  let AuthKey = localStorage.getItem("AuthKey");
  if (AuthKey) {
    config.headers.authkey = AuthKey;
  }
  let emailId = localStorage.getItem("emailId");
  if (emailId) {
    config.headers.userid = emailId;
  }
  if (documentType) {
    config.headers.documentType = documentType;
  }
  if (AWBNo) {
    config.headers.AWBNo = AWBNo;
  }
  return config;
};
export const post = async (url, formBody = null, headers = null) => {
   
  headers = await setHeaders(headers);
  return new Promise((resolve, reject) => {
    axios
      .post(url, formBody, headers)
      .then((json) => {
        console.log(url);
        resolve(json.data);
      })
      .catch((err) => {
        //window.location.href="/login"
        if (
          err.response &&
          err.response.status &&
          err.response.status === 404
        ) {
          alert("Method Not Found " + url);
        }
        if (
          err.response &&
          err.response.status &&
          err.response.status === 401
        ) {
          window.location.href = "/login";
        }
        reject(err);
      });
  });
};

export const Upload = async (url, formData, documentType, AWBNo) => {
  let headers = await setHeadersUpload(documentType, AWBNo);
  return new Promise((resolve, reject) => {
    axios
      .post(url, formData, headers)
      .then((json) => {
        resolve(json);
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.status &&
          err.response.status === 404
        ) {
          alert("Method Not Found " + url);
        }
        if (
          err.response &&
          err.response.status &&
          err.response.status === 401
        ) {
          window.location.href = "/login";
        }
        reject(err);
      });
  });
};
export const get = async (url, headersData = null) => {
  headersData = await setHeaders(headersData);
  return new Promise((resolve, reject) => {
    axios
      .get(url, { headers: headersData["headers"] })
      .then((json) => {
        console.log(url);
        resolve(json.data);
      })
      .catch((err) => {
        //alert("cascas");
        if (
          err.response &&
          err.response.status &&
          err.response.status === 404
        ) {
          alert("Method Not Found " + url);
        }
        if (
          err.response &&
          err.response.status &&
          err.response.status === 401
        ) {
          //  localStorage.clear();
          // alert("Session Expired")
          window.location.href = "/login";
          //alert("ss")
        }
        reject(err);
      });
  });
};
export const put = async (url, formBody = null, headers = null) => {
  headers = await setHeaders(headers);
  return new Promise((resolve, reject) => {
    axios
      .put(url, formBody, headers)
      .then((json) => {
        console.log(url);
        resolve(json.data);
      })
      .catch((err) => {
        //alert("cascas");
        if (
          err.response &&
          err.response.status &&
          err.response.status === 404
        ) {
          alert("Method Not Found " + url);
        }
        if (
          err.response &&
          err.response.status &&
          err.response.status === 401
        ) {
          //  localStorage.clear();
          // alert("Session Expired")
        }
        reject(err);
      });
  });
};
export const deleterecord = async (
  url,
  formBody = null,
  headersData = null
) => {
  headersData = await setHeaders(headersData);
  return new Promise((resolve, reject) => {
    axios
      .delete(url, { params: formBody, headers: headersData["headers"] })
      .then((json) => {
        resolve(json.data);
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.status &&
          err.response.status === 404
        ) {
          alert("Method Not Found " + url);
        }
        if (
          err.response &&
          err.response.status &&
          err.response.status === 401
        ) {
          // window.location.replace("/sessionexpired");
        }
        reject(err);
      });
  });
};
